import { render, staticRenderFns } from "./ExternalLayout.vue?vue&type=template&id=0b855346"
import script from "./ExternalLayout.vue?vue&type=script&lang=js"
export * from "./ExternalLayout.vue?vue&type=script&lang=js"
import style0 from "./ExternalLayout.vue?vue&type=style&index=0&id=0b855346&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports